import styled from 'styled-components';

export const ScheduleFieldWrap = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const ScheduleItemWrap = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 20px 20px 15px 20px;
  margin-bottom: 10px;
  border: solid 1px #ccc;
  border-radius: 5px;
`;

export const ScheduleItemRemoveWrap = styled.div`
  position: absolute;
  right: -5px;
  top: -5px;
  display: flex;
  width: 15px;
  height: 15px;
  background: #fff;
  align-items: center;
  justify-content: center;
  border: solid 1px #ccc;
  border-radius: 30px;
  cursor: pointer;
  .MuiSvgIcon-root {
    font-size: 11px;
    color: #999;
  }
`;

export const ScheduleControlArea = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px 0 15px 0;
`;

export const ScheduleError = styled.div`
  font-size: 14px;
  color: #9c3737;
  padding-right: 20px;
`;
